import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../AdminAuthContext";

// Settings is for Admins and the Super Admin only.
export const SettingsGuard = ({ children }) => {
  const { admin } = useAdminAuth();
  if (!admin) return null;
  const roles = admin.roles?.length ? admin.roles : [admin.role];
  return roles.some((r) => r === "admin" || r === "super_admin") ? children : <Navigate to="/admin/dashboard" replace />;
};
